const GENERIC_NAMES = new Set(['user', 'guest']);

/** Auto-generated placeholder names from OTP register (mirrors backend rules). */
export function isPlaceholderName(name) {
  if (!name || !String(name).trim()) return true;
  const n = String(name).trim();
  if (GENERIC_NAMES.has(n.toLowerCase())) return true;
  if (/^user_\d+$/i.test(n)) return true;
  if (/^User \d{4}$/.test(n)) return true;
  return false;
}

/** Legacy OTP accounts may have @phone.proppins.local — API masks as null; keep client guard. */
export function isPlaceholderEmail(email) {
  if (!email || !String(email).trim()) return true;
  return String(email).trim().toLowerCase().endsWith('@phone.proppins.local');
}

export function isValidProfileEmail(email) {
  if (!email || isPlaceholderEmail(email)) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}
export function getUserPhoneDigits(user) {
  const raw = user?.phone_number || user?.phone || '';
  return String(raw).replace(/\D/g, '');
}

export function hasValidProfilePhone(user) {
  return getUserPhoneDigits(user).length >= 10;
}

/**
 * Profile is complete enough to submit a contact lead with customer details.
 * Prefer backend `profile_complete` when present (source of truth).
 */
export function isUserProfileComplete(user) {
  if (!user) return false;
  if (typeof user.profile_complete === 'boolean') {
    return user.profile_complete;
  }
  const name = user.name || user.username || '';
  if (isPlaceholderName(name)) return false;
  if (!isValidProfileEmail(user.email)) return false;
  if (!hasValidProfilePhone(user)) return false;
  return true;
}
export function getDisplayName(user) {
  const name = user?.name || user?.username || '';
  return isPlaceholderName(name) ? '' : String(name).trim();
}
